import React from 'react';
import Widget from './Widget';
import Table from './d3/Table';
import BenchmarkTable from './d3/BenchmarkTable';

const TableWrapper = ({
    data,
    benchmarkData,
    institutionDetails,
    onExplainMdrm,
    reportType,
    onMdrmFilterChange,
    onSearchKeysChange,
    searchKeys,
    benchmarkRSSDs,
    startQuarter,
    endQuarter,
    lockedInstitute,
}) => (
    <Widget title="Table" className="table-widget">
        {reportType === 'benchmark' ? (
            <BenchmarkTable
                data={benchmarkData}
                onExplainMdrm={onExplainMdrm}
                institutionDetails={institutionDetails}
                searchKeys={searchKeys}
                onSearchKeysChange={onSearchKeysChange}
                benchmarkRSSDs={benchmarkRSSDs}
                lockedInstitute={lockedInstitute}
            />
        ) : (
            <Table
                data={data}
                onExplainMdrm={onExplainMdrm}
                onMdrmFilterChange={onMdrmFilterChange}
                onSearchKeysChange={onSearchKeysChange}
                searchKeys={searchKeys}
                startQuarter={startQuarter}
                endQuarter={endQuarter}
            />
        )}
    </Widget>
);

export default TableWrapper;
